(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-imessage"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    document.querySelectorAll('.fqi').forEach(function (section) {
      section.classList.add('fqi--js');

      var targets = section.querySelectorAll('.fqi__pair, .fqi__stamp');
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.2, rootMargin: '0px 0px -8% 0px' }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-press"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var sections = document.querySelectorAll('[data-press-section]');

    if (!sections.length) {
      return;
    }

    function clamp(value, min, max) {
      return Math.min(Math.max(value, min), max);
    }

    function updateSection(section) {
      var cards = section.querySelectorAll('[data-press-card]');
      var rect = section.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
      var centeredProgress = (progress - 0.5) * 2;
      var strength = parseFloat(getComputedStyle(section).getPropertyValue('--press-motion-strength')) || 32;

      cards.forEach(function (card, index) {
        var direction = 0;

        if (index === 0) {
          direction = -1;
        } else if (index === cards.length - 1) {
          direction = 1;
        } else if (index % 2 === 0) {
          direction = 0.55;
        } else {
          direction = -0.55;
        }

        card.style.setProperty('--press-card-shift', String(direction * centeredProgress * strength) + 'px');
      });
    }

    function updateAll() {
      sections.forEach(updateSection);
    }

    updateAll();
    window.addEventListener('scroll', updateAll, { passive: true });
    window.addEventListener('resize', updateAll);
    document.addEventListener('shopify:section:load', updateAll);
    document.addEventListener('shopify:section:reorder', updateAll);
    document.addEventListener('shopify:block:select', updateAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
